/**
 * Created by Kieran on 26/09/2017.
 */

import config from '../../config'
import axios from 'axios'


let GeoApi = {
  geoIp() {
    return axios.get(config.apiUrl + 'geoIp')
  }
}

export default GeoApi;



// WEBPACK FOOTER //
// ./src/api/Geo/index.js